import React from "react";
import DashBoard from "./Components/index";
import useFilter from "Hooks/useFilter";
import queryString from "query-string";
import { fromMonthly, toMonthly } from "fuction/date";
import { withRouter } from "react-router";
import { message } from "constants/message";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const filter = useFilter();
  const auth = useAuth();
  const messages = message();
  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);
  const { status } = queryString.parse(props.location.search);
  const activeGroup = auth.state.activeGroup;
  const onClickLineChart = (date) => {
    props.history.push(`/dashboard/daily?activeGroup=${activeGroup}&date=${date}`);
  };
  const onClickListButton = (date) => {
    props.history.push(`/dashboard/details?activeGroup=${activeGroup}&date=${date}&interval=monthly`);
  };
  const onClickReTweet = (id) => {
    props.history.push(
      `/retweets/monthly?activeGroup=${activeGroup}&id=${id}&dateTo=${toDate}&dateFrom=${fromDate}`
    );
  };
  const onClickUser = (screen_name) => {
    props.history.push(
      `/users/details?activeGroup=${activeGroup}&user=${screen_name}&dateTo=${toDate}&dateFrom=${fromDate}`
    );
  };
  const onClickKeyword = (word) => {
    props.history.push(
      `/keywords/monthly?activeGroup=${activeGroup}&word=${word}&dateTo=${toDate}&dateFrom=${fromDate}`
    );
  };

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - ダッシュボード";

    switch (status) {
      case "201":
        alert(messages.dashboard.passwordReset);
        break;
      default:
        break;
    }
  }, []);

  return (
    <DashBoard
      fromDate={fromDate}
      toDate={toDate}
      target="monthly"
      unit="date"
      onClickLineChart={onClickLineChart}
      onClickListButton={onClickListButton}
      onClickReTweet={onClickReTweet}
      onClickUser={onClickUser}
      onClickKeyword={onClickKeyword}
    />
  );
}

export default withRouter(Page);
